import nextId from "react-id-generator";
import icon from "../../images/check-icon.svg"

export const pricingItems = [
    {
        id: nextId(),
        icon: icon,
        text: "personal training"
    },
    {
        id: nextId(),
        icon: icon,
        text: "cardio exercise"
    },
    {
        id: nextId(),
        icon: icon,
        text: "weight lifting"
    },
    {
        id: nextId(),
        icon: icon,
        text: "diet plans"
    },
    {
        id: nextId(),
        icon: icon,
        text: "overall results"
    },
]